// The browser side of OF.Components.Site.HashLink. Following a same-page link
// fires `popstate`, which Hologram takes for back/forward and answers by
// mounting the page the document was first loaded with; its listener is on
// `window` and runs before any other there, so the popstate cannot be stopped.
// The link is followed here instead: a history entry carrying Hologram's own
// state, the scroll, and `is-target` on the element (`:target` only follows a
// real navigation). Any `a[href^="#"]` on the page is covered.

function markTarget(element) {
  for (const marked of document.querySelectorAll(".is-target")) {
    if (marked !== element) marked.classList.remove("is-target");
  }

  element?.classList.add("is-target");
}

function elementFor(hash) {
  return hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
}

if (!globalThis.ofHashLinks) {
  globalThis.ofHashLinks = true;

  document.addEventListener(
    "click",
    (event) => {
      const plain =
        event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      const link = plain && !event.defaultPrevented && event.target.closest?.('a[href^="#"]');
      const target = link && elementFor(link.hash);

      if (!target) return;

      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(history.state, "", link.hash);
      target.scrollIntoView({block: "start"});
      markTarget(target);

      // Where a followed fragment would leave the keyboard.
      if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
      target.focus({preventScroll: true});
    },
    true,
  );

  // Back and forward between two of those entries on the same page move the
  // mark; arriving from another page leaves it off.
  window.addEventListener("popstate", () => markTarget(elementFor(location.hash)));
}

export function installed() {
  return globalThis.ofHashLinks === true;
}
